var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _ellipse, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShuttleVehicle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 140,
    viewBox: "0 0 141 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 70,
    r: 64,
    fill: "url(#paint0_linear_1852_417367)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M102.989 90.0977C102.989 94.4297 106.536 98.0778 110.998 98.0778C115.46 98.0778 119.007 94.5437 119.007 90.0977",
    fill: "#739CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.989 90.0977C102.989 94.4297 106.536 98.0778 110.998 98.0778C115.46 98.0778 119.007 94.5437 119.007 90.0977",
    stroke: "#195FE9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.43 90.0977C114.43 92.0357 112.829 93.5177 110.998 93.5177C109.053 93.5177 107.565 91.9217 107.565 90.0977",
    fill: "#739CFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114.43 90.0977C114.43 92.0357 112.829 93.5177 110.998 93.5177C109.053 93.5177 107.565 91.9217 107.565 90.0977",
    stroke: "#195FE9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8492 90.0977C40.8492 94.5437 37.3023 98.0778 32.84 98.0778C29.247 98.0778 26.2474 95.7125 25.2152 92.5294C25.3889 92.1706 25.5374 91.1225 25.5374 90.0977H40.8492Z",
    fill: "#739CFF",
    stroke: "#195FE9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2725 90.0977C36.2725 92.0357 34.6707 93.5177 32.8401 93.5177C30.895 93.5177 29.4076 91.9217 29.4076 90.0977",
    fill: "#739CFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2725 90.0977C36.2725 92.0357 34.6707 93.5177 32.8401 93.5177C30.895 93.5177 29.4076 91.9217 29.4076 90.0977",
    stroke: "#195FE9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M110.28 46.8906C110.623 47.0046 121.264 46.8906 129.158 46.8906C132.362 46.8906 134.65 49.3987 134.879 52.4767L137.168 86.3352C137.282 88.0453 135.909 89.5273 134.193 89.5273L116.692 89.7572",
    fill: "#E5EEFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M117.55 46.8906H130.891L135.104 51.8241L136.993 86.7121L135.978 89.1778H121.061L120.358 70.5009L119.656 51.8241L117.55 46.8906Z",
    fill: "url(#paint1_linear_1852_417367)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M98.4211 90.0973H108.907C108.907 90.0973 114.742 89.7553 118.403 89.6413C120.005 89.5273 121.264 88.2733 121.264 86.6772V73.339C120.806 63.8769 120.348 54.0727 118.632 49.1707C118.175 47.8026 116.802 46.8906 115.314 46.8906C104.559 46.8906 63.4837 46.8906 46.3213 46.8906C42.5456 46.8906 38.8843 48.3726 36.0239 50.9947C30.7607 55.8968 22.0651 64.1049 18.6327 67.2969C17.6029 68.209 16.5732 68.893 15.3146 69.463C12.683 70.603 8.10638 72.541 5.13157 73.795C3.52974 74.4791 2.5 76.0751 2.5 77.7851V85.3092C2.5 87.9313 4.6739 90.0973 7.30547 90.0973H9.59379",
    fill: "#E5EEFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M98.4211 90.0973H108.907C108.907 90.0973 114.742 89.7553 118.403 89.6413C120.005 89.5273 121.264 88.2733 121.264 86.6772V73.339C120.806 63.8769 120.348 54.0727 118.632 49.1707C118.175 47.8026 116.802 46.8906 115.314 46.8906C104.559 46.8906 63.4837 46.8906 46.3213 46.8906C42.5456 46.8906 38.8843 48.3726 36.0239 50.9947C30.7607 55.8968 22.0651 64.1049 18.6327 67.2969C17.6029 68.209 16.5732 68.893 15.3146 69.463C12.683 70.603 8.10638 72.541 5.13157 73.795C3.52974 74.4791 2.5 76.0751 2.5 77.7851V85.3092C2.5 87.9313 4.6739 90.0973 7.30547 90.0973H9.59379",
    stroke: "#195FE9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4977 90.0977H84.4219",
    stroke: "#195FE9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6391 56.2617L46.1466 72.5023L45.6735 85.7486C45.6543 86.2866 45.2125 86.7129 44.6741 86.7129H29.7209C29.2396 86.7129 28.8225 86.3727 28.6746 85.9148C28.0448 83.964 25.819 79.0798 19.2357 78.6264C18.6847 78.5885 18.233 78.1449 18.233 77.5926V71.9948",
    stroke: "#195FE9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6992 86.2062H78.3196C78.7945 86.2062 79.2009 85.8703 79.3691 85.4262C80.3853 82.7429 84.0436 78.0859 89.7932 78.0859C95.6706 78.0859 99.1172 81.9058 100.133 83.2261C100.341 83.4971 100.658 83.6686 101 83.6686H136.5",
    stroke: "#195FE9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0112 73.0078H41.0714",
    stroke: "#195FE9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.70813 90.0966C9.70813 85.7645 13.255 82.2305 17.6028 82.2305C21.9506 82.2305 25.4975 85.7645 25.4975 90.0966C25.4975 94.4287 21.9506 97.9627 17.6028 97.9627C13.255 97.9627 9.70813 94.4287 9.70813 90.0966ZM14.1704 90.0966C14.1704 92.0346 15.6578 93.5166 17.6028 93.5166C19.5479 93.5166 21.0353 92.0346 21.0353 90.0966C21.0353 88.1586 19.5479 86.6765 17.6028 86.6765C15.7722 86.6765 14.1704 88.1586 14.1704 90.0966Z",
    stroke: "#195FE9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M90.2864 82.2305C85.9386 82.2305 82.3917 85.7645 82.3917 90.0966C82.3917 94.4287 85.9386 97.9627 90.2864 97.9627C94.6342 97.9627 98.1811 94.4287 98.1811 90.0966C98.1811 85.7645 94.6342 82.2305 90.2864 82.2305Z",
    fill: "#E5EEFF",
    stroke: "#195FE9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M110.28 46.8906C110.623 47.0046 121.264 46.8906 129.158 46.8906C132.362 46.8906 134.65 49.3987 134.879 52.4767L137.168 86.3352C137.282 88.0453 135.909 89.5273 134.193 89.5273L116.692 89.7572",
    stroke: "#195FE9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M48.5 55.7143L111.18 55L112.5 70H51.799L48.5 55.7143Z",
    fill: "url(#paint2_linear_1852_417367)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M35.3927 56.7595L43.1168 56.0547L41.7124 68.036L25.9185 70.1504L23.4554 68.7408L35.3927 56.7595Z",
    fill: "url(#paint3_linear_1852_417367)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0033 57.6063L43.7481 57.6942C43.7515 57.6651 43.7533 57.6357 43.7533 57.6063H43.0033ZM41.6303 56.2383L41.736 55.4958C41.6834 55.4883 41.6303 55.4864 41.5773 55.4902L41.6303 56.2383ZM36.7972 56.5803L36.8393 57.3292L36.8502 57.3284L36.7972 56.5803ZM22.7534 68.7785L22.234 68.2374C22.0572 68.4072 21.9745 68.6526 22.0125 68.8948C22.0505 69.1369 22.2044 69.3452 22.4247 69.4526L22.7534 68.7785ZM25.5622 70.148L25.2335 70.8221C25.354 70.8809 25.488 70.9062 25.6216 70.8956L25.5622 70.148ZM39.1131 68.7785L39.2164 69.5213L39.2188 69.521L39.1131 68.7785ZM42.2024 65.7004L42.9448 65.8069C42.9483 65.7824 42.9506 65.7578 42.9516 65.7331L42.2024 65.7004ZM43.7533 57.6063C43.7533 57.3597 43.7132 57.0856 43.6341 56.8293C43.5581 56.5833 43.4245 56.2833 43.1894 56.049L42.1306 57.1116C42.1243 57.1053 42.1624 57.1473 42.2008 57.2718C42.2361 57.386 42.2533 57.5109 42.2533 57.6063H43.7533ZM43.1894 56.049C43.0214 55.8816 42.8118 55.7864 42.6803 55.734C42.5298 55.674 42.3726 55.6289 42.2406 55.596C42.106 55.5625 41.9821 55.5379 41.8927 55.5217C41.8475 55.5135 41.8101 55.5073 41.7832 55.503C41.7697 55.5008 41.7588 55.4992 41.7509 55.498C41.7469 55.4974 41.7436 55.4969 41.7411 55.4965C41.7399 55.4963 41.7388 55.4962 41.7379 55.4961C41.7375 55.496 41.7371 55.4959 41.7368 55.4959C41.7366 55.4959 41.7365 55.4958 41.7363 55.4958C41.7363 55.4958 41.7362 55.4958 41.7361 55.4958C41.736 55.4958 41.736 55.4958 41.6303 56.2383C41.5246 56.9808 41.5245 56.9808 41.5244 56.9808C41.5244 56.9808 41.5243 56.9808 41.5243 56.9808C41.5242 56.9807 41.5241 56.9807 41.524 56.9807C41.5239 56.9807 41.5238 56.9807 41.5238 56.9807C41.5237 56.9807 41.5238 56.9807 41.524 56.9807C41.5246 56.9808 41.5258 56.981 41.5278 56.9813C41.5316 56.9819 41.5382 56.9829 41.5471 56.9843C41.5649 56.9871 41.5918 56.9916 41.6253 56.9976C41.6932 57.0099 41.7838 57.0281 41.878 57.0515C41.9749 57.0757 42.0609 57.1018 42.1249 57.1274C42.2079 57.1604 42.1842 57.165 42.1306 57.1116L43.1894 56.049ZM41.5773 55.4902L36.7443 55.8322L36.8502 57.3284L41.6832 56.9864L41.5773 55.4902ZM25.5622 70.148C25.6216 70.8956 25.6216 70.8956 25.6217 70.8956C25.6218 70.8956 25.6219 70.8956 25.622 70.8956C25.6223 70.8956 25.6227 70.8955 25.6232 70.8955C25.6243 70.8954 25.6259 70.8953 25.628 70.8951C25.6323 70.8948 25.6386 70.8943 25.6469 70.8936C25.6635 70.8923 25.6882 70.8903 25.7205 70.8877C25.7852 70.8825 25.8806 70.8748 26.0038 70.8647C26.25 70.8446 26.6071 70.8151 27.0509 70.7775C27.9384 70.7024 29.1731 70.5952 30.5619 70.4665C33.3356 70.2096 36.7381 69.8659 39.2164 69.5213L39.0098 68.0356C36.5683 68.3751 33.1953 68.7162 30.4235 68.9729C29.0396 69.1011 27.809 69.208 26.9244 69.2829C26.4822 69.3203 26.1265 69.3497 25.8815 69.3697C25.7591 69.3797 25.6642 69.3874 25.6001 69.3925C25.568 69.3951 25.5437 69.3971 25.5273 69.3984C25.5191 69.399 25.513 69.3995 25.5089 69.3999C25.5068 69.4 25.5053 69.4001 25.5043 69.4002C25.5038 69.4003 25.5034 69.4003 25.5031 69.4003C25.503 69.4003 25.5029 69.4003 25.5029 69.4003C25.5028 69.4003 25.5028 69.4003 25.5622 70.148ZM39.2188 69.521C41.149 69.2462 42.6684 67.7345 42.9448 65.8069L41.4599 65.594C41.2787 66.8584 40.2809 67.8547 39.0074 68.036L39.2188 69.521ZM42.9516 65.7331C43.0645 63.1467 43.517 59.651 43.7481 57.6942L42.2584 57.5184C42.0318 59.4377 41.569 63.01 41.4531 65.6677L42.9516 65.7331ZM22.4247 69.4526L25.2335 70.8221L25.8909 69.4739L23.0821 68.1043L22.4247 69.4526ZM36.7552 55.8315C36.1919 55.8631 35.6038 56.0718 35.0293 56.3619C34.447 56.6559 33.8301 57.0586 33.199 57.5292C31.9372 58.4701 30.5598 59.7267 29.206 61.0547C27.8494 62.3853 26.4989 63.8052 25.2926 65.0786C24.079 66.3597 23.023 67.48 22.234 68.2374L23.2728 69.3195C24.0943 68.5309 25.1816 67.3768 26.3815 66.1102C27.5888 64.8358 28.9219 63.4345 30.2564 62.1255C31.5935 60.8139 32.9146 59.6124 34.0957 58.7317C34.686 58.2915 35.2268 57.9425 35.7054 57.7009C36.1919 57.4552 36.5679 57.3443 36.8393 57.3291L36.7552 55.8315Z",
    fill: "#195FE9"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0608 56.2188C49.6265 56.2188 49.1922 56.4375 48.8665 56.7656C48.5407 57.0938 48.4321 57.5313 48.5407 57.9687C49.0836 60.375 49.9523 64.5313 50.6037 67.2656C50.9295 68.9062 52.4496 70 54.0783 70H111.734C112.169 70 112.712 69.7812 113.037 69.4531C113.363 69.125 113.58 68.5781 113.472 68.1406C113.255 65.625 112.929 61.0312 112.712 58.2969C112.603 56.9844 111.517 56 110.214 56C99.1391 56.1094 59.9417 56.2188 50.0608 56.2188Z",
    stroke: "#195FE9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M118.403 89.6413C120.005 89.5273 121.264 88.2733 121.264 86.6772M121.264 86.6772V73.339L121.249 73.0285C120.796 63.6631 120.33 54.0191 118.632 49.1707C118.175 47.8026 116.802 46.8906 115.314 46.8906H46.3213C42.5456 46.8906 38.8843 48.3726 36.0239 50.9947C30.7607 55.8968 22.0651 64.1049 18.6327 67.2969C17.6029 68.209 16.5732 68.893 15.3146 69.463C12.683 70.603 8.10638 72.541 5.13157 73.795C3.52974 74.4791 2.5 76.0751 2.5 77.7851V85.3092C2.5 87.9313 4.6739 90.0973 7.30547 90.0973H9.59379M121.264 86.6772L121.264 73.4525C120.806 63.9903 120.348 54.1862 118.632 49.2841",
    stroke: "#195FE9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M113.5 70C116.27 70 131 70 131 70C132.619 70 133.183 69.0233 132.981 67.8295L132.671 58C132.5 57 131.853 56 130.5 56C130.5 56 119.546 56 115.5 56",
    stroke: "#195FE9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 101.335,
    cy: 43.3626,
    rx: 29.165,
    ry: 29.2727,
    fill: "white",
    stroke: "#195FE9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M92.9442 26.7088H86.0194C84.7446 26.7088 83.7112 27.8202 83.7112 29.1911V56.4959C83.7112 57.8668 84.7446 58.9781 86.0194 58.9781H116.027C117.301 58.9781 118.335 57.8668 118.335 56.4959V29.1911C118.335 27.8202 117.301 26.7088 116.027 26.7088H109.102H92.9442Z",
    fill: "#E5EEFF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1984 28.3968C92.1984 28.8086 92.5323 29.1425 92.9442 29.1425C93.356 29.1425 93.6899 28.8086 93.6899 28.3968H92.1984ZM93.6899 24.2266C93.6899 23.8147 93.356 23.4808 92.9442 23.4808C92.5323 23.4808 92.1984 23.8147 92.1984 24.2266H93.6899ZM108.356 28.3968C108.356 28.8086 108.69 29.1425 109.102 29.1425C109.514 29.1425 109.848 28.8086 109.848 28.3968H108.356ZM109.848 24.2266C109.848 23.8147 109.514 23.4808 109.102 23.4808C108.69 23.4808 108.356 23.8147 108.356 24.2266H109.848ZM86.0194 27.4545H92.9442V25.9631H86.0194V27.4545ZM92.9442 27.4545H109.102V25.9631H92.9442V27.4545ZM109.102 27.4545H116.027V25.9631H109.102V27.4545ZM116.027 27.4545C116.839 27.4545 117.589 28.18 117.589 29.1911H119.081C119.081 27.4603 117.763 25.9631 116.027 25.9631V27.4545ZM117.589 29.1911V56.4959H119.081V29.1911H117.589ZM117.589 56.4959C117.589 57.5069 116.839 58.2324 116.027 58.2324V59.7239C117.763 59.7239 119.081 58.2267 119.081 56.4959H117.589ZM116.027 58.2324H86.0194V59.7239H116.027V58.2324ZM86.0194 58.2324C85.2066 58.2324 84.4569 57.5069 84.4569 56.4959H82.9655C82.9655 58.2267 84.2827 59.7239 86.0194 59.7239V58.2324ZM84.4569 56.4959V29.1911H82.9655V56.4959H84.4569ZM84.4569 29.1911C84.4569 28.18 85.2066 27.4545 86.0194 27.4545V25.9631C84.2827 25.9631 82.9655 27.4603 82.9655 29.1911H84.4569ZM93.6899 28.3968V26.7088H92.1984V28.3968H93.6899ZM93.6899 26.7088V24.2266H92.1984V26.7088H93.6899ZM109.848 28.3968V26.7088H108.356V28.3968H109.848ZM109.848 26.7088V24.2266H108.356V26.7088H109.848Z",
    fill: "#195FE9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0393 40.1562H114.007V47.3962H88.0393V40.1562Z",
    fill: "white",
    stroke: "#195FE9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0393 53.1875H112.564",
    stroke: "#195FE9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0393 34.3633H112.564",
    stroke: "#195FE9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M111.843 63.3199C117.022 63.3199 121.22 59.106 121.22 53.908C121.22 48.7099 117.022 44.4961 111.843 44.4961C106.664 44.4961 102.466 48.7099 102.466 53.908C102.466 59.106 106.664 63.3199 111.843 63.3199Z",
    fill: "white",
    stroke: "#195FE9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M108.236 55.113L109.503 56.637C109.893 57.1059 110.608 57.1197 111.016 56.6662L115.449 51.7344",
    stroke: "#195FE9",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1852_417367",
    x1: 36.5,
    y1: 212,
    x2: 116,
    y2: 11.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#195FE9",
    stopOpacity: 0.04
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#87AAFF",
    stopOpacity: 0.75
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1852_417367",
    x1: 109.314,
    y1: 88.1394,
    x2: 109.314,
    y2: 54.8692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87AAFF",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#195FE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1852_417367",
    x1: 98.778,
    y1: 69.5424,
    x2: 98.778,
    y2: 54.8822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87AAFF",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#195FE9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1852_417367",
    x1: 27.1086,
    y1: 69.6989,
    x2: 27.1086,
    y2: 55.2336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#87AAFF",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#195FE9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShuttleVehicle);
export default __webpack_public_path__ + "static/media/ShuttleVehicle.84a12100c232d18bfe3d1a2ef5e3f290.svg";
export { ForwardRef as ReactComponent };